
import {
    HttpInterceptorFn,
    HttpRequest,
    HttpHandlerFn,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
    withInterceptors
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LayoutState } from 'src/app/layout/layout.state';
import { Router } from '@angular/router';

/* ————————————————————————————————————
   1. Credentials + token interceptor
———————————————————————————————————— */
export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    //const auth = inject(AuthService);

    let cloned = req;

    // 1️⃣ withCredentials if needed
    if (!environment.api.sameHost) {
        cloned = cloned.clone({ withCredentials: true });
    }

    // // 2️⃣ custom token header (if available)
    // const token = auth.getLoggedInUserInfo()?.authToken;
    // if (token) {
    //     cloned = cloned.clone({
    //         setHeaders: {
    //             UserAuthenticationToken: token,
    //             isFromAngular: 'true'
    //         }
    //     });
    // }

    return next(cloned);
};

/* ————————————————————————————————————
   2. Loader + global error / session handling
———————————————————————————————————— */
export const loaderAndErrorInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const layoutState = inject(LayoutState);
    const router = inject(Router);

    // Active‑request list for this interceptor instance
    const active: string[] = [];
    const trackLoader = req.params.get('showLoader') === 'true';

    if (trackLoader) {
        active.push(req.urlWithParams);
        layoutState.setLoadingStatus(true);
    }

    const finish = () => {
        const i = active.indexOf(req.urlWithParams);
        if (i > -1) active.splice(i, 1);
        if (active.length === 0) layoutState.setLoadingStatus(false);
    };

    return next(req).pipe(
        tap({
            next: (evt) => {
                if (evt instanceof HttpResponse) {
                    finish();
                }
            },
            error: (err: HttpErrorResponse) => {
                finish();

                switch (err.status) {
                    case 0:
                    case -1:
                    case 400:
                        // toastr.error('Server Not Responding');
                        break;

                    case 401:
                        // allow evidence API 401s to bubble
                        // if (err.url?.startsWith(environment.evidenceIntegrationApiUrl)) {
                        //     throw err;
                        // }
                        // redirectToLogin();
                        break;

                    case 403:
                        // toastr.error('You are not authorized to access this page.');
                        router.navigate(['/unauthorize']);
                        break;

                    case 500:
                    case 302:
                        // window.location.href = `${environment.angularAppUrl}/error/exception-error`;
                        break;

                    default:
                        /* re‑throw for caller */
                        throw err;
                }
            }
        })
    );
};


/* ————————————————————————————————————
   3. Unwrap the ASMX response 
———————————————————————————————————— */
export const unwrapASMXResponseInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
  ): Observable<HttpEvent<unknown>> => {
    return next(req).pipe(
      map(event => {
        if (
          event instanceof HttpResponse &&
          event.body !== null &&
          typeof event.body === 'object' &&
          'd' in event.body
        ) {
          return event.clone({ body: (event.body as any).d });
        }
        return event;
      })
    );
  };
/* ————————————————————————————————————
   Helper to register both interceptors
———————————————————————————————————— */
export const httpInterceptorProviders = withInterceptors([
     authInterceptor,
     unwrapASMXResponseInterceptor,
     loaderAndErrorInterceptor
]);